var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:("bg-" + _vm.color)},[_c('div',{staticClass:"container mx-auto p-4"},_vm._l((_vm.bannerLinks),function(link){return _c('contact-highlight',_vm._b({key:link.title},'contact-highlight',link,false))}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }